import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {MiscelaneaService} from '../../services/miscelanea.service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

const SELECT_PORTAL_LANG_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectPortalLangComponent)
};

@Component({
    selector: 'app-select-portal-lang',
    template: `
      <ngx-select [items]="portalLangs" [(ngModel)]="selectedValue" [optionValueField]="valueField" [optionTextField]="textField" (select)="selected($event)" [allowClear]="true">
          <ng-template ngx-select-option ngx-select-option-selected let-option let-text="text">
              {{ option.data.lang }}
          </ng-template>
      </ngx-select>
      `,
    styleUrls: ['./select-portal-lang.component.scss'],
    providers: [SELECT_PORTAL_LANG_VALUE_ACCESSOR]
})
export class SelectPortalLangComponent implements OnInit, ControlValueAccessor {

    portalLangs: Array<Object> = [];
    _selectedValue: string;
    valueField: string = 'lang';
    textField: string = 'lang';

    constructor(private miscelanea: MiscelaneaService) { }

    ngOnInit() {
        this.miscelanea.findLangs().subscribe(
            (result) => {
                this.portalLangs = result;
            }
        )
    }

    selected(value: any) {
        this.propagateChange(this._selectedValue);
    }


    get selectedValue(): any { return this._selectedValue; };

    set selectedValue(v: any) {
        this._selectedValue = v;
        this.propagateChange(this._selectedValue);
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(value: any): void {
        this._selectedValue = value;
    }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/select-portal-lang/select-portal-lang.component.ts